module.exports = __webpack_public_path__ + "img/3052539.png";